export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? "http://localhost:8080";

/*
 ?? -> O operador de coalescência nula (??) é um operador 
    lógico que retorna o seu operando do lado direito quando o seu operador 
    do lado esquerdo é null ou undefined. Caso contrário, ele retorna o 
    seu operando do lado esquerdo.
*/
